import gql from 'graphql-tag';
import userInfoFragment from '../user/userInfo';

export default gql`
  fragment communityMemberInfo on CommunityMember {
    id
    user {
      ...userInfo
    }
    isMember
    isModerator
    isBlocked
    isOwner
    isPending
    isExpert
    isChair
    roles
    reputation
    description
  }
  ${userInfoFragment}
`;
